/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Open360BusinessLogicCategoriesInventoryListItem } from './open360BusinessLogicCategoriesInventoryListItem';


export interface Open360EntitiesRetailerApiCampaignListItem {
    ID?: number;
    RetailerID?: number;
    Name?: string;
    StartDate?: Date;
    EndDate?: Date;
    DailyStartTime?: string;
    DailyEndTime?: string;
    /**
     * 1 = Sunday, 2 = Monday, 4 = Tuesday, 8 = Wednesday, 16 = Thursday, 32 = Friday, 64 = Saturday
     */
    DaysOfWeek?: Open360EntitiesRetailerApiCampaignListItem.DaysOfWeekEnum;
    JispExclusive?: boolean;
    Views?: number;
    Clicks?: number;
    /**
     * 1 = Draft, 2 = AdSubmission, 3 = QualityControl, 4 = Active, 5 = Archived
     */
    EntityStatus?: Open360EntitiesRetailerApiCampaignListItem.EntityStatusEnum;
    ImageID?: number;
    VideoID?: number;
    VideoUrl?: string;
    /**
     * 1 = Running, 2 = Archived, 3 = Completed, 4 = Error, 5 = Disabled, 6 = Warning, 7 = Scheduled, 8 = Draft, 9 = AdSubmission, 10 = QualityControl, 13 = Undefined, 14 = VideoProcessing, 15 = VideoProcessingError
     */
    Status?: Open360EntitiesRetailerApiCampaignListItem.StatusEnum;
    StatusMessage?: string;
    CreateDate?: Date;
    Competition?: boolean;
    Line1?: string;
    Line2?: string;
    Line3?: string;
    /**
     * 1 = ExtraSmall, 2 = Small, 3 = Medium, 4 = Large, 5 = ExtraLarge
     */
    Line1FontSize?: Open360EntitiesRetailerApiCampaignListItem.Line1FontSizeEnum;
    /**
     * 1 = ExtraSmall, 2 = Small, 3 = Medium, 4 = Large, 5 = ExtraLarge
     */
    Line2FontSize?: Open360EntitiesRetailerApiCampaignListItem.Line2FontSizeEnum;
    /**
     * 1 = ExtraSmall, 2 = Small, 3 = Medium, 4 = Large, 5 = ExtraLarge
     */
    Line3FontSize?: Open360EntitiesRetailerApiCampaignListItem.Line3FontSizeEnum;
    TemplateName?: string;
    TemplateColour?: number;
    /**
     * 1 = Offer, 2 = Promotion, 3 = Advert, 4 = FlashSale, 5 = Event, 6 = Voucher, 8 = SpecialEvent
     */
    Type?: Open360EntitiesRetailerApiCampaignListItem.TypeEnum;
    IsExclusiveOffer?: boolean;
}
export namespace Open360EntitiesRetailerApiCampaignListItem {
    export type DaysOfWeekEnum = 1 | 2 | 4 | 8 | 16 | 32 | 64;
    export const DaysOfWeekEnum = {
        NUMBER_1: 1 as DaysOfWeekEnum,
        NUMBER_2: 2 as DaysOfWeekEnum,
        NUMBER_4: 4 as DaysOfWeekEnum,
        NUMBER_8: 8 as DaysOfWeekEnum,
        NUMBER_16: 16 as DaysOfWeekEnum,
        NUMBER_32: 32 as DaysOfWeekEnum,
        NUMBER_64: 64 as DaysOfWeekEnum
    }
    export type EntityStatusEnum = 1 | 2 | 3 | 4 | 5;
    export const EntityStatusEnum = {
        NUMBER_1: 1 as EntityStatusEnum,
        NUMBER_2: 2 as EntityStatusEnum,
        NUMBER_3: 3 as EntityStatusEnum,
        NUMBER_4: 4 as EntityStatusEnum,
        NUMBER_5: 5 as EntityStatusEnum
    }
    export type StatusEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 13 | 14 | 15;
    export const StatusEnum = {
        NUMBER_1: 1 as StatusEnum,
        NUMBER_2: 2 as StatusEnum,
        NUMBER_3: 3 as StatusEnum,
        NUMBER_4: 4 as StatusEnum,
        NUMBER_5: 5 as StatusEnum,
        NUMBER_6: 6 as StatusEnum,
        NUMBER_7: 7 as StatusEnum,
        NUMBER_8: 8 as StatusEnum,
        NUMBER_9: 9 as StatusEnum,
        NUMBER_10: 10 as StatusEnum,
        NUMBER_13: 13 as StatusEnum,
        NUMBER_14: 14 as StatusEnum,
        NUMBER_15: 15 as StatusEnum
    }
    export type Line1FontSizeEnum = 1 | 2 | 3 | 4 | 5;
    export const Line1FontSizeEnum = {
        NUMBER_1: 1 as Line1FontSizeEnum,
        NUMBER_2: 2 as Line1FontSizeEnum,
        NUMBER_3: 3 as Line1FontSizeEnum,
        NUMBER_4: 4 as Line1FontSizeEnum,
        NUMBER_5: 5 as Line1FontSizeEnum
    }
    export type Line2FontSizeEnum = 1 | 2 | 3 | 4 | 5;
    export const Line2FontSizeEnum = {
        NUMBER_1: 1 as Line2FontSizeEnum,
        NUMBER_2: 2 as Line2FontSizeEnum,
        NUMBER_3: 3 as Line2FontSizeEnum,
        NUMBER_4: 4 as Line2FontSizeEnum,
        NUMBER_5: 5 as Line2FontSizeEnum
    }
    export type Line3FontSizeEnum = 1 | 2 | 3 | 4 | 5;
    export const Line3FontSizeEnum = {
        NUMBER_1: 1 as Line3FontSizeEnum,
        NUMBER_2: 2 as Line3FontSizeEnum,
        NUMBER_3: 3 as Line3FontSizeEnum,
        NUMBER_4: 4 as Line3FontSizeEnum,
        NUMBER_5: 5 as Line3FontSizeEnum
    }
    export type TypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 8;
    export const TypeEnum = {
        NUMBER_1: 1 as TypeEnum,
        NUMBER_2: 2 as TypeEnum,
        NUMBER_3: 3 as TypeEnum,
        NUMBER_4: 4 as TypeEnum,
        NUMBER_5: 5 as TypeEnum,
        NUMBER_6: 6 as TypeEnum,
        NUMBER_8: 8 as TypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360EntitiesRetailerApiCampaignListItem.ts